import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faCloudDownload } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";


import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { campaignList, getOrderReports, analyzeWinnersList, analizeWinners, getGeneralData } from "../../../controllers/V1/lottoWinnersControllers";
import * as XLSX from 'xlsx';
import Loading from "../../../components/Loading/LoadingEffect";
import PreviewPopUp from "./PreviewPopUp";
import FinalPopup from "./FinalPopUp";
import { useNavigate } from "react-router-dom";
import { formatProjectDate } from "../../../controllers/common";
import {create as createLog} from "../../../controllers/activeLogsController";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};


export default function BasicTabs() {

  const [error, setError] = useState({});
  const navigate = useNavigate();
  /************************************************************************************* */
  const [pageLoading, setPageLoading] =useState(true);
  const [isLoading, setIsLoading] =useState(true);
  const [detailsLoading, setDetailsLoading] =useState(false);
  const [exportLoading, setExportLoading] =useState(false);
  const targetRef = useRef(null);
  const winningCouponRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [campaignListData, setCampaignListData] = useState([]);
  const [ALLLISTDATA, setListData] = useState([]);
  const [PRIZEDATA, setPrizeData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(20);
  const [SKIP, setSkip] = useState(0);
  const [searchParams, setSearchParams] = useState({});

  const [usersDetails, setUsersDetails] = useState([]);
  const [orderStatic, setOrderStatic] = useState({});

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [searchValue, setSearchValue] = useState("");
  const [viewData, setViewData] = useState([]);
  const [matchingCode, setMatchingCode] = useState("");
  const [finalData, setFinalData] = useState([]);
  const [gameType, setGameType] = useState("");
  const adminUser = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const getCampaignList = async () => {
    try {
        setIsLoading(true);
        setPageLoading(true);
        const options = {
            type: "",
            condition: { status : 'A' },
        }
        const res = await campaignList(options);    
        if(res.status === true){
            setCampaignListData(res.result);
        }
        setIsLoading(false);
        setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
    }
  }

  const fetchGeneralData = async () => {
    try {
        const options = { }
        const res = await getGeneralData(options);    
        if(res.status === true){
        const { analyser_end_time, analyser_start_time } = res.result;
        if(!analyser_end_time || !analyser_start_time){
          alert('Please add analyser working time in General Data.');
          navigate('/dashboard');
        } else{
          const analyserStartHr = parseInt(moment(`2025-02-23 ${analyser_start_time}`).format('HH'));
          const analyserStartMin = parseInt(moment(`2025-02-23 ${analyser_start_time}`).format('mm'));
          const analyserTotalStartMin = analyserStartHr * 60 + analyserStartMin;
          
          const analyserEndHr = parseInt(moment(`2025-02-23 ${analyser_end_time}`).format('HH'));
          const analyserEndMin = parseInt(moment(`2025-02-23 ${analyser_end_time}`).format('mm'));
          const analyserTotalEndMin = analyserEndHr * 60 + analyserEndMin;
  
          const now = await formatProjectDate(new Date());
          const currentHr = parseInt(moment(now).format('HH'));
          const currentMin = parseInt(moment(now).format('mm'));
          const constCurrentMin = currentHr * 60 + currentMin;
  
          if(analyserTotalStartMin < constCurrentMin && analyserTotalEndMin > constCurrentMin){
            console.log('in between')
          } else{
            alert('Access denied! Please come on time.')
            navigate('/dashboard');
          }
        }
      }
    } catch (error) {
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getCampaignList();
    fetchGeneralData();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "K-Winn || Lotto Winner's Analyser";
  }, []);

  useEffect(() => {
    let filteredData = [...ALLLISTDATA];
    if(ALLLISTDATA && ALLLISTDATA?.length > 0){
      if (searchValue.trim() !== "") {
        const lowerQuery = searchValue.toLowerCase();
        filteredData = filteredData.filter(item =>
          Object.values(item).some(value =>
            String(value).toLowerCase().includes(lowerQuery)
          )
        );
      }
      setTotalPages(Math.ceil(filteredData?.length / LIMIT));
      const paginatedData = filteredData.slice(
        (currentPage - 1) * LIMIT,
        currentPage * LIMIT
    );
    setFilteredData(paginatedData);
    }
  },[currentPage])


  const [PARAMS, setParams] = useState({});
  const handleChange = (e) => { 
    const { name, value } = e.target;
    setParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  const analyzeWinnerData = async (e) => {
    e.preventDefault();
    try {
      setPageLoading(true);
      setFilteredData([]);
      setListData([]);
      setSortConfig({ key: null, direction: "asc" });
      const formData = new FormData(e.target);
      if(!formData.get('campaign')){
          setError((pre)=>({
              ...pre,
              campaign : "Campaign is required."
          }))
      } else if(!formData.get('draw_date')){
          setError((pre)=>({
              ...pre,
              draw_date : "Draw Date is required."
          }));
      } else if(!PRIZEDATA){
          setError((pre)=>({
              ...pre,
              campaign : "Prize not fount."
          }));    
      } else{
        const campaignData = JSON.parse(formData.get('campaign'));
        const orderStaticOption = {
          campaignId : campaignData?._id,
          date : formData.get('draw_date')
        }
        const orderStaticRes = await getOrderReports(orderStaticOption);
        if(orderStaticRes?.status === true){
          setOrderStatic(orderStaticRes?.result);
        }
        const finalParam = {
          game_id : campaignData?._id,
          draw_date : formData.get('draw_date'),
          ...(formData.get('coupon') && {coupon : formData.get('coupon')}),
          price : {
            ...((
                parseInt(PARAMS?.lotto_type) === 5 ||
                parseInt(PARAMS?.lotto_type) === 4 ||
                parseInt(PARAMS?.lotto_type) === 3 
            )?{
              straight  : formData.get('straight_prize') || 0, 
              rumble    : formData.get('rumble_prize') || 0,
            }:{
              straight  : 0,
              rumble    : 0,
            }),
            match1      : parseInt(formData.get('match_1')) || 0,
            match2      : parseInt(formData.get('match_2')) || 0,
            match3      : parseInt(formData.get('match_3')) || 0,
            match4      : parseInt(formData.get('match_4')) || 0,
            match5      : parseInt(formData.get('match_5')) || 0,
            match6      : parseInt(formData.get('match_6')) || 0,
            match7      : parseInt(formData.get('match_7')) || 0
          },
          filter : {
            ...(formData.get('filter_straight') && {straight : formData.get('filter_straight')}),
            ...(formData.get('straight_number') && {straight_number : formData.get('straight_number')}),
            ...(formData.get('filter_rumble')   && {rumble : formData.get('filter_rumble')}),
            ...(formData.get('rumble_number')   && {rumble_number : formData.get('rumble_number')}),

            ...(formData.get('match1')          && {match1 : formData.get('match1')}),
            ...(formData.get('match1_number')   && {match1_number : formData.get('match1_number')}),
            ...(formData.get('match2')          && {match2 : formData.get('match2')}),
            ...(formData.get('match2_number')   && {match2_number : formData.get('match2_number')}),
            ...(formData.get('match3')          && {match3 : formData.get('match3')}),
            ...(formData.get('match3_number')   && {match3_number : formData.get('match3_number')}),
            ...(formData.get('match4')          && {match4 : formData.get('match4')}),
            ...(formData.get('match4_number')   && {match4_number : formData.get('match4_number')}),
            ...(formData.get('match5')          && {match5 : formData.get('match5')}),
            ...(formData.get('match5_number')   && {match5_number : formData.get('match5_number')}),
            ...(formData.get('match6')          && {match6 : formData.get('match6')}),
            ...(formData.get('match6_number')   && {match6_number : formData.get('match6_number')}),
            ...(formData.get('match7')          && {match7 : formData.get('match7')}),
            ...(formData.get('match7_number')   && {match7_number : formData.get('match7_number')}),
          }
          // suggestions_count : 10
        }
        const res = await analyzeWinnersList(finalParam);
        const logParam = {
          log : `${adminUser?.admin_email} run winner analyse for ${campaignData?.title}`,
          payload : {...finalParam?.price, ...finalParam?.filter, game : campaignData?.title, draw_date : finalParam?.draw_date, coupon : finalParam?.coupon}
        }
        createLog(logParam);
        if(res?.status === true){
          setSearchParams(finalParam);
          const finalData = res.result?.finaldata;
          setListData(finalData || []);
          const paginatedData = finalData.slice(
              (currentPage - 1) * LIMIT,
              currentPage * LIMIT
          );
          setFilteredData(paginatedData);
          setTotalPages(Math.ceil(finalData?.length / LIMIT));
        }
      }
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      console.log(error, "error")
    }
  }  
  
const handleGameChange = async (e) => {
  try {
    winningCouponRef.current.value = "";
    // setPageLoading(true);
    setFilteredData([]);
    setListData([]);
    const { name, value } = e.target;
    const campaignData = JSON.parse(value);
    setGameType(campaignData?.title || 'N/A');
    // return 
    setParams((prev) => ({
      ...prev,
      [name]: campaignData?._id,
      lotto_type : campaignData?.lotto_type
    }));

    if(parseInt(campaignData?.lotto_type) === 6 || parseInt(campaignData?.lotto_type) === 7){
      setParams((prev) => ({
        ...prev,
        type : 'rumble'
      }));
    } else{
      setParams((prev) => ({
        ...prev,
        type : 'chance',
        straight : true,
        rumble : true
      }));
    }
    
    //Fetch Prize data
    
    if(campaignData && campaignData?.prizeData){
        setPrizeData(campaignData?.prizeData);
    }
    setPageLoading(false);
  } catch (error) {
    setPageLoading(false);
    setFilteredData([]);
    setListData([]);
  }
}

const handleExportData = async () =>{
  setExportLoading(true);
  try {
    if(ALLLISTDATA && ALLLISTDATA.length > 0){
      const {price} = searchParams;
      console.log('prize : ', searchParams);
      
      const modifiedData = ALLLISTDATA.map((items, index) => {
        let totalCount = 0;
    
        return {
          "Sl. No.": index + 1,
          "Match Coupon": items?.ticket?.join(",") || "",
          "Area": items?.area|| "",
  
          ...(parseInt(PARAMS?.lotto_type) >= 3 && parseInt(PARAMS?.lotto_type) <= 5
            ? {
              "Straight Price": parseFloat(items?.straight || 0) * parseFloat(price?.straight || 0),
              "Straight Count": items?.straight,
              "Rumble Price": parseFloat(items?.rumble || 0) * parseFloat(price?.rumble || 0),
              "Rumble Count": items?.rumble,
              }
            : {}),
  
          ...(PARAMS?.lotto_type
            ? Object.assign(
              {},
              ...Array.from({ length: PARAMS.lotto_type }, (_, i) => {
                  const matchIndex = PARAMS.lotto_type - i;
                  if (PARAMS?.lotto_type > 6 && matchIndex < 3) return null;

                  totalCount += parseInt(items[`match${matchIndex}`], 10) || 0;

                  return {
                      [`${matchIndex} ${PARAMS?.type} Win Amt.`]: parseFloat(items[`match${matchIndex}`] || 0) * parseFloat(price[`match${matchIndex}`] || 0),
                      [`${matchIndex} ${PARAMS?.type} Win Count`]: items[`match${matchIndex}`],
                  };
              }).filter(Boolean)
            )
          : {}),

          "Total Count" : totalCount || 0,
          "Total Amt." : items?.total_amount || 0
        };
    });
    const workbook = XLSX.utils.book_new();
    const worksheet1 = XLSX.utils.json_to_sheet(modifiedData);

    XLSX.utils.book_append_sheet(workbook, worksheet1, "Matching Winners");
    XLSX.writeFile(workbook, `Winner's List ${moment().format('YYYY-MM-DD')}.xlsx`);
    setExportLoading(false);
  }
} catch (error) {
  setExportLoading(false);
  console.log('error : ', error)   
  }
}

const handleViewUsers = async (data={}, type="") => {
    setDetailsLoading(true);
    try {
      if(data && type){
        let finaldata = [];
        const option = {
          ...searchParams,
          coupon : data?.ticket?.join(',')
        }
        if(option?.coupon === matchingCode){
          finaldata = viewData;
        } else{
          setMatchingCode(option?.coupon);
          const res = await analizeWinners(option);
          if(res?.status === true){
            setViewData(res?.result?.finaldata || []);
            finaldata = res?.result?.finaldata || [];
          }
        }
  
        if(finaldata?.length > 0){
          setDetailsLoading(false);
          if(type === 'straight' && finaldata?.length > 0 && finaldata[0]?.straight_user?.length > 0){
            setUsersDetails(finaldata[0]?.straight_user);
          } else if(type === 'rumble' && finaldata?.length > 0 && finaldata[0]?.rumble_user?.length > 0) {
            setUsersDetails(finaldata[0]?.rumble_user);
          } else if(type === 'all'){
            const rumble    = await getWinnersList(finaldata, 'rumble');
            const straight  = await getWinnersList(finaldata, 'straight');
            const match1    = await getWinnersList(finaldata, 'match1');
            const match2    = await getWinnersList(finaldata, 'match2');
            const match3    = await getWinnersList(finaldata, 'match3');
            const match4    = await getWinnersList(finaldata, 'match4');
            const match5    = await getWinnersList(finaldata, 'match5');
            const match6    = await getWinnersList(finaldata, 'match6');
            const match7    = await getWinnersList(finaldata, 'match7');
            const allData = [ ...rumble, ...straight, ...match1, ...match2, ...match3, ...match4, ...match5, ...match6, ...match7 ];
            allData.sort((a, b) => b["WINNING AMOUNT"] - a["WINNING AMOUNT"]);
            setFinalData(allData || []);
          } else{
            setUsersDetails(finaldata[0]?.[`${type}_user`]);
          }
        } else{
          setDetailsLoading(false);
          alert('User not found');
        }
      }
    } catch (error) {
      setDetailsLoading(false);
      console.log('error : ', error);
    }
  
}

const getWinnersList = async (data, type) => {
  try {
    if(data?.length > 0){
      const result = Promise.all(data[0][`${type}_user`].map(async (item, index) => {
        return{
          "Sl.No"             : index + 1,
          "TICKET ID"         : item?.order_no,
          "SELLER FIRST NAME" : item?.seller_first_name,
          "SELLER LAST NAME"  : item?.seller_last_name,
          "SELLER MOBILE"     : item?.seller_mobile,
          "COUPONS"           : item?.ticket?.join(","), 
          "STRAIGHT AMOUNT"   : type === 'straight' ? 1 : 0,
          "RUMBLE AMOUNT"     : type === 'rumble' ? 1 : 0,
          "CHANCE AMOUNT"     : (
            type === 'match1' ||
                                  type === 'match2' ||
                                  type === 'match3' ||
                                  type === 'match4' ||
                                  type === 'match5' ||
                                  type === 'match6' ||
                                  type === 'match7' 
                                ) ? 1 : 0,

          ...(type === 'straight' && { 
              "WINNER TYPE" : 'Straight Prize',
              "WINNING AMOUNT"    : parseFloat(data[0][`${type}`]) / parseFloat(data[0][`${type}_count`])
            }),
          ...(type === 'rumble' && { 
            "WINNER TYPE" : 'Rumble Prize',
            "WINNING AMOUNT"    : parseFloat(data[0][`${type}_price`]) / parseFloat(data[0][`${type}_count`])
          }),
          ...((
            type === 'match1' || 
            type === 'match2' || 
            type === 'match3' || 
            type === 'match4' || 
            type === 'match5' || 
            type === 'match6' || 
            type === 'match1'
          ) && { 
            "WINNER TYPE" : 'Chance Prize',
            "WINNING AMOUNT"    : parseFloat(data[0][`${type}_price`]) / parseFloat(data[0][`${type}_count`])
          }),
          "MATCHING NUMBER"   : item?.user_matches,
        }
      }));
      return result;
    } else {
      return [];
    }
  } catch (error) {

  }
}


const handleSort = (key) => {
  try {
    let filteredData = [...ALLLISTDATA];
    // Perform search
    if (searchValue.trim() !== "") {
      const lowerQuery = searchValue.toLowerCase();
      filteredData = filteredData.filter(item =>
        Object.values(item).some(value =>
          String(value).toLowerCase().includes(lowerQuery)
        )
      );
    }

    // Perform sort
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);


    const sortedData = filteredData.sort((a, b) => {
      const valA = a[key] ?? 0;
      const valB = b[key] ?? 0;

      if (typeof valA === "string" && typeof valB === "string") {
        return direction === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }

      return direction === "asc" ? valA - valB : valB - valA;
    });

    setTotalPages(Math.ceil(sortedData?.length / LIMIT));

    // Paginate after sorting and searching
    const paginatedData = sortedData.slice(
      (currentPage - 1) * LIMIT,
      currentPage * LIMIT
    );
    setFilteredData(paginatedData);
  } catch (error) {
    console.log('error:', error);
  }
};

const straightNumberRef = useRef(null);
const rumbleNumberRef = useRef(null);
const matchRefs = useRef({});

const handleMatchChange = (e) => {
try {
  const {name} = e.target;
  if(name === 'filter_straight'){
    straightNumberRef.current.value = "";
  } else if(name === 'filter_rumble'){
    rumbleNumberRef.current.value = "";
  }else{
    matchRefs.current[`${name}_number`].value ="";
  }
} catch (error) {
  
}
}

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Analyse winner"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <form onSubmit={analyzeWinnerData}>
                <div className="row inventory_all_tabs">
                    <div className="form-group row">
                        <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                            <label htmlFor="campaign" className="all_section_for_label_main_class" >
                                <span style={{ color: "red" }}>*</span>Campaign :{" "}
                            </label>
                            <select className="form-control store_input_field" id="campaign" name="campaign" onChange={handleGameChange} >  
                                <option value={''} selected disabled>Select Campaign</option>
                                {campaignListData?.length > 0 && campaignListData.map((items, index)=>(
                                    <option key={index} value={JSON.stringify(items)} selected={PARAMS?.campaign === items?._id ? true : false} >{items?.title}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                            <label htmlFor="draw_date" className="all_section_for_label_main_class" >
                                <span style={{ color: "red" }}>*</span>Draw Date :{" "}
                            </label>
                            <input type="date" className="form-control store_input_field" onChange={handleChange} name="draw_date" id="draw_date" />
                        </div>

                        <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                            <label htmlFor="suggestions_count" className="all_section_for_label_main_class" >
                                Winning Coupon  :
                            </label>
                            <input type="text" className="form-control store_input_field" onChange={handleChange} ref={winningCouponRef} name="coupon" id="coupon" />
                        </div>
                        <div className="row">
                        {(
                          parseInt(PARAMS?.lotto_type) === 5 ||
                          parseInt(PARAMS?.lotto_type) === 4 ||
                          parseInt(PARAMS?.lotto_type) === 3 
                        ) && (<>
                          <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                            <label htmlFor="suggestions_count" className="all_section_for_label_main_class" >
                                Straight :
                            </label>
                            <input type="number" value={PRIZEDATA[`straight_prize${PARAMS?.lotto_type}`]} className="form-control store_input_field" onChange={handleChange} name="straight_prize" id="straight_prize" />
                          </div>

                          <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                            <label htmlFor="suggestions_count" className="all_section_for_label_main_class" >
                                Rumble :
                            </label>
                            <input type="number" value={PRIZEDATA[`rumble_prize${PARAMS?.lotto_type}`]} className="form-control store_input_field" onChange={handleChange} name="rumble_prize" id="rumble_prize" />
                          </div>
                        </>)}


                        {PARAMS?.lotto_type ? (
                          Array.from({ length: PARAMS?.lotto_type }, (_, i) => PARAMS?.lotto_type - i)
                            .map((index) => 
                              ((PARAMS?.lotto_type > 5 && index > 2) || PARAMS?.lotto_type < 6) ? (
                                <div key={index} className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                  <label htmlFor={`match_${index}`} className="all_section_for_label_main_class">
                                    Match {index} : {PARAMS?.type}
                                  </label>
                                  <input 
                                    type="number" 
                                    className="form-control store_input_field" 
                                    onChange={handleChange} 
                                    value={PRIZEDATA[`${PARAMS?.type}_prize${index}`]}
                                    name={`match_${index}`} 
                                    id={`match_${index}`} 
                                  />
                                </div>
                              ) : null
                            )
                        ) : null}
                        </div>
                        {/* Filter Section */}
                        <div className="row">
                          {(
                            parseInt(PARAMS?.lotto_type) === 5 ||
                            parseInt(PARAMS?.lotto_type) === 4 ||
                            parseInt(PARAMS?.lotto_type) === 3 
                          ) && (<>
                            <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                              <label htmlFor="filter_straight" className="all_section_for_label_main_class" >
                                  Straight Winner :
                              </label>
                              <select name="filter_straight" className="form-control store_input_field" onChange={handleMatchChange}>
                                <option value={''}>All</option>
                                <option value={'equal_to'} >Equal to</option>
                                <option value={'greater_than'} >Greater than</option>
                                <option value={'less_than'} >Less than</option>
                              </select>
                            </div>
                            <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                              <label htmlFor="straight_number" className="all_section_for_label_main_class" >Number</label>
                              <input type="number" className="form-control store_input_field" ref={straightNumberRef} name="straight_number" id="straight_number" />
                            </div>

                            <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                              <label htmlFor="filter_rumble" className="all_section_for_label_main_class" >
                                  Rumble Winner:
                              </label>
                              <select name="filter_rumble" className="form-control store_input_field" onChange={handleMatchChange}>
                                <option value={''}>All</option>
                                <option value={'equal_to'} >Equal to</option>
                                <option value={'greater_than'} >Greater than</option>
                                <option value={'less_than'} >Less than</option>
                              </select>
                            </div>
                            <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12 ">
                              <label htmlFor="rumble_number" className="all_section_for_label_main_class" >
                                  Number:
                              </label>
                              <input type="number" className="form-control store_input_field" ref={rumbleNumberRef} name="rumble_number" id="rumble_number" />
                            </div>
                          </>)}

                          {PARAMS?.lotto_type ? (
                            Array.from({ length: PARAMS?.lotto_type }, (_, i) => PARAMS?.lotto_type - i)
                              .map((index) => 
                                ((PARAMS?.lotto_type > 5 && index > 2) || PARAMS?.lotto_type < 6) ? (<>
                                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                    <label htmlFor={`match${index}`} className="all_section_for_label_main_class">
                                      Chance {index} winner
                                    </label>
                                    <select name={`match${index}`} className="form-control store_input_field" onChange={handleMatchChange}>
                                      <option value={''}>All</option>
                                      <option value={'equal_to'} >Equal to</option>
                                      <option value={'greater_than'} >Greater than</option>
                                      <option value={'less_than'} >Less than</option>
                                    </select>
                                  </div>

                                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                    <label htmlFor={`match${index}_number`} className="all_section_for_label_main_class">
                                      Chance {index} : number
                                    </label>
                                    <input 
                                      type="number" 
                                      className="form-control store_input_field" 
                                      ref={(el) => matchRefs.current[`match${index}_number`] = el}
                                      name={`match${index}_number`} 
                                      id={`match${index}_number`} 
                                    />
                                  </div>
                                </>
                                ) : null
                              )
                          ) : null}
                        </div>
                        {/* Filter Section End */}

                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="inventory_open_popup_action_btn">
                                <button type="submit" className="btn btn-danger"> Analyse </button>
                            </div>
                        </div>
                    </div>
                </div>
              </form>
            </Box>

            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      {/* {filteredData?.length > 0 && (<> */}
                      {orderStatic && orderStatic?.length > 0 && (
                        <div className="row">
                          <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <label htmlFor="campaign" className="all_section_for_label_main_class" ></label>
                            <h4>Total Orders : {parseInt(orderStatic.find(item => item._id === 'Success')?.total_qty || 0) + parseInt(orderStatic.find(item => item._id === 'Cancel')?.total_qty || 0)}</h4>
                          </div>

                          <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <label htmlFor="campaign" className="all_section_for_label_main_class" ></label>
                            <h4>Cancel Orders : {orderStatic.find(item => item._id === 'Cancel')?.total_qty || 0}</h4>
                          </div>
                          <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <label htmlFor="campaign" className="all_section_for_label_main_class" ></label>
                            <h4>Success Orders : {orderStatic.find(item => item._id === 'Success')?.total_qty || 0}</h4>
                          </div>

                          <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div className="inventory_open_popup_action_btn">
                              <button type='button' className="btn btn-danger" onClick={handleExportData} ><FontAwesomeIcon icon={ faCloudDownload }/> Export</button>
                            </div>
                          </div>

                        </div>
                      )}
                        <div className="row">
                          <div className="form-group col-lg-10 col-md-10 col-sm-10 col-xs-12">
                            <input type="test" name="searchValue" id="searchValue" className="form-control store_input_field" onChange={(e)=>setSearchValue(e.target.value)}  placeholder="Search" />
                          </div>
                          <div className="form-group col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <button type="button" className="btn btn-danger" onClick={()=>handleSort("")} >Search</button>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table
                            className="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th>Sl. No.</th>
                                <th> Win Coupon </th>
                                <th onClick={() => handleSort(`area`)}> {`Area `} 
                                {(sortConfig.key === `area` && sortConfig?.direction === 'desc') ? <FontAwesomeIcon icon={faArrowUp} />:<FontAwesomeIcon icon={faArrowDown} />}  
                                </th>
                                {(
                                  parseInt(PARAMS?.lotto_type) === 5 ||
                                  parseInt(PARAMS?.lotto_type) === 4 ||
                                  parseInt(PARAMS?.lotto_type) === 3 
                                ) && (<>
                                  <th
                                    onClick={() => handleSort(`straight`)}
                                  >
                                    Straight Count
                                    {(sortConfig.key === `straight` && sortConfig?.direction === 'desc') ? <FontAwesomeIcon icon={faArrowUp} />:<FontAwesomeIcon icon={faArrowDown} />}  
                                  </th>
                                  <th>Straight Amt.</th>

                                  <th
                                    onClick={() => handleSort(`rumble`)}
                                  >Rumble Count
                                    {(sortConfig.key === `rumble` && sortConfig?.direction === 'desc') ? <FontAwesomeIcon icon={faArrowUp} />:<FontAwesomeIcon icon={faArrowDown} />}
                                  </th> 
                                  <th>Rumble Amt.</th>
                                </>)}
                                

                                {PARAMS?.lotto_type ? (
                                  Array.from({ length: PARAMS?.lotto_type }, (_, i) => PARAMS?.lotto_type - i).map((matchIndex) =>  {
                                      if (PARAMS?.lotto_type > 5 && matchIndex < 3){
                                        return null
                                      } else{
                                        return (
                                        <React.Fragment key={matchIndex}>
                                          <th 
                                            onClick={() => handleSort(`match${matchIndex}`)} 
                                          >
                                            {`${matchIndex} ${PARAMS?.type} Count`}
                                            {(sortConfig.key === `match${matchIndex}` && sortConfig?.direction === 'desc') ? <FontAwesomeIcon icon={faArrowUp} />:<FontAwesomeIcon icon={faArrowDown} />}
                                          </th>
                                          <th>{`${matchIndex} ${PARAMS?.type} Amt.`}</th>
                                        </React.Fragment>
                                        );
                                      }
                                  })
                                ) : null}

                                <th>Total Count</th>
                                <th onClick={() => handleSort("total_amount")} >Total Amt. {(sortConfig.key === 'total_amount' && sortConfig?.direction === 'desc') ? <FontAwesomeIcon icon={faArrowUp} />:<FontAwesomeIcon icon={faArrowDown} />}</th>
                              </tr>
                            </thead>

                            <tbody>
                            {filteredData?.length > 0 ? (
                              filteredData.map((items, index) => {
                                  let totalCount = 0;
                                  totalCount += items?.straight || 0;
                                  totalCount += items?.rumble || 0;
                                  return (
                                  <tr key={index}>
                                      <td>{SKIP + index + 1}</td>
                                      <td>{items?.ticket?.join(",")}</td>
                                      <td>{items?.area}</td>
                                      {(
                                        parseInt(PARAMS?.lotto_type) === 5 ||
                                        parseInt(PARAMS?.lotto_type) === 4 ||
                                        parseInt(PARAMS?.lotto_type) === 3 
                                      ) && (<>
                                        <td>
                                          {items?.straight}
                                          {parseInt(items?.straight) > 0 && (
                                            <button type="button" className="btn btn-info" onClick={()=> handleViewUsers(items, "straight")}>View</button>
                                          )}
                                        </td>
                                        <td>
                                          {items?.straight * PRIZEDATA[`straight_prize${PARAMS?.lotto_type}`] }
                                        </td>

                                        <td>
                                          {items?.rumble}
                                          {items?.rumble > 0 && (
                                            <button type="button" className="btn btn-info" onClick={()=> handleViewUsers(items, "rumble")}>View</button>
                                          )}
                                        </td>
                                        <td>{items?.rumble * PRIZEDATA[`rumble_prize${PARAMS?.lotto_type}`]}</td>
                                      </>)}
                                      {PARAMS?.lotto_type ? (
                                      Array.from({ length: PARAMS?.lotto_type }, (_, i) => PARAMS?.lotto_type - i).map((matchIndex) =>  {
                                          if (PARAMS?.lotto_type > 5 && matchIndex < 3) return null
                                          totalCount += parseInt(items[`match${matchIndex}`]) || 0
                                          return (
                                          <React.Fragment key={matchIndex}>
                                            <td>
                                              {items[`match${matchIndex}`]}
                                              {items[`match${matchIndex}`] > 0 && (
                                                <button type="button" className="btn btn-info" onClick={()=> handleViewUsers(items, `match${matchIndex}`)}>View</button>
                                              )}
                                            </td>
                                            <td>
                                              {items[`match${matchIndex}`] * PRIZEDATA[`${PARAMS?.type}_prize${matchIndex}`]}
                                            </td>
                                          </React.Fragment>
                                          );
                                      })
                                      ) : null}

                                      <td>
                                        {totalCount > 0 && (
                                            <button type="button" className="btn btn-info-total" onClick={()=> handleViewUsers(items, "all")}>{`${totalCount} View`}</button>
                                        )}
                                      </td>
                                      <td>{items?.total_amount || 0}</td>
                                  </tr>
                                  );
                              })
                              ) : isLoading ? (
                              <SkeltonList row={5} col={6} />
                              ) : (
                              <tr>
                                  <td colSpan="12" className="img-center">No data found!</td>
                              </tr>
                              )}

                            </tbody>
                          </table>
                          <div className="table_pagination_sales_order">
                            <Pagination
                              count={TOTALPAGES}
                              onChange={handlePageChange}
                            />
                          </div>
                        </div>
                      {/* </>)} */}
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      <Loading isLoading={pageLoading} text="Preparing matches! Please wait..."/>
      <Loading isLoading={detailsLoading} text="Fetching details! Please wait..."/>
      <Loading isLoading={exportLoading} text="Preparing excel! Please wait..."/>
      {usersDetails && usersDetails?.length > 0 && (
        <PreviewPopUp popUpOpen={true} togglePopUp={setUsersDetails} usersDetails={usersDetails}  />
      )}

      {finalData && finalData?.length > 0 && (
        <FinalPopup popUpOpen={true} togglePopUp={setFinalData} usersDetails={finalData} campaignData={gameType || ""} matchingCode={matchingCode || ""} />
      )}
    </>
  );
}
